import * as THREE from 'three';

import xmldom from 'xmldom';

export default class GHXLoader extends THREE.FileLoader {
  load (url, onLoad, onProgress, onError) {
    super.load(
      url,
      (text) => {
        onLoad(this.parse(text));
      }, onProgress, onError);
  }

  parse (ghx) {
    const parser = new xmldom.DOMParser();
    const dom = parser.parseFromString(ghx, 'application/xml');
    return dom;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/GHXLoader.js